import React from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { getUserFoldersAndFiles } from "../api";
import ImportUsersModal from "./ImportUsersModal";

interface AdminHeaderOptionsProps {
  adminMenuAnchorEl: HTMLElement | null;
  handleAdminMenuClick: (event: React.MouseEvent<HTMLElement>) => void;
  handleAdminMenuClose: () => void;
}

const AdminHeaderOptions: React.FC<AdminHeaderOptionsProps> = ({
  adminMenuAnchorEl,
  handleAdminMenuClick,
  handleAdminMenuClose,
}) => {
  const navigate = useNavigate();

  const handleNavigateToAdmin = () => {
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");

    if (user.type === 99) {
      navigate("/admin");
    } else {
      alert(
        "Acesso negado: somente administradores podem acessar esta página."
      );
    }

    handleAdminMenuClose();
  };

  const handleNavigateToUser = async () => {
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");

    if (!user?.login) {
      alert("Usuário não autenticado.");
      return;
    }

    try {
      const foldersAndFiles = await getUserFoldersAndFiles(user.login);
      sessionStorage.setItem("userFolders", JSON.stringify(foldersAndFiles)); // Salva os dados no sessionStorage
      navigate("/user");
    } catch (error) {
      console.error("Erro ao buscar pastas e arquivos:", error);
      alert("Erro ao carregar pastas e arquivos do usuário.");
    }

    handleAdminMenuClose(); // Fecha o menu
  };

  return (
    <>
      <Button
        onClick={handleAdminMenuClick}
        color="inherit"
        sx={{
          textTransform: "none",
          color: "white",
          mr: 2,
          display: "flex",
          alignItems: "center",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 0.1)",
          },
        }}
      >
        Área de Administrador
        <MenuIcon sx={{ ml: 1 }} />
      </Button>
      <Menu
        anchorEl={adminMenuAnchorEl}
        open={Boolean(adminMenuAnchorEl)}
        onClose={handleAdminMenuClose}
      >
        <MenuItem onClick={handleNavigateToAdmin}>
          Cadastro de Usuários
        </MenuItem>
        <MenuItem onClick={handleNavigateToUser}>
          Explorador de Arquivos
        </MenuItem>
      </Menu>
    </>
  );
};

export default AdminHeaderOptions;
